import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { allschools } from "../../apis/urls";
import jsPDF from 'jspdf';
import { useParams } from 'react-router-dom';

const SchooldirectoryPdf = () => {
  const pdfRef = useRef(null);
  const [resultall, setResultall] = useState([]);

  useEffect(() => {
    const fetchSchoolData = async () => {
      try {
        const response = await axios.get(allschools);
        console.log("Response data is", response.data);
        setResultall(response.data.data);
      } catch (error) {
        console.error('Error fetching school data:', error.message);
      }
    };

    fetchSchoolData();
  }, []);

  // const generatePDFoneschool = (resultall) => {
  //   const doc = new jsPDF('p', 'mm', 'a4');
  //   const pageWidth = doc.internal.pageSize.getWidth();
  //   const pageHeight = doc.internal.pageSize.getHeight();
  
  //   // Set margins
  //   const margins = { top: 20, bottom: 20, left: 10, right: 10 };
  //   let y = margins.top;
  //   let page = 1;
  
  //   const addPageBorderAndNumber = () => {
  //     doc.setDrawColor(0);
  //     doc.setLineWidth(0.5);
  //     doc.rect(margins.left - 5, margins.top - 5, pageWidth - margins.left - margins.right + 10, pageHeight - margins.top - margins.bottom + 15);
  //     doc.setFontSize(10);
  //     const pageNumberYPosition = pageHeight - margins.bottom + 18;
  //     doc.text(`Page ${page}`, pageWidth / 2, pageNumberYPosition, { align: 'center' });
  //   };
  
  //   const addTextWithPageBreak = (text, x, y) => {
  //     const maxY = pageHeight - margins.bottom - 10;
  //     if (y > maxY) {
  //       doc.addPage();
  //       y = margins.top;
  //       page++;
  //       addPageBorderAndNumber();
  //     }
  //     doc.text(text, x, y);
  //     return y + 4;
  //   };
  
  //   // Add title
  //   doc.setFontSize(16);
  //   doc.setFont(undefined, 'bold');
  //   doc.setTextColor(255, 0, 0); // Red color
  //   doc.text('Schools Directory', pageWidth / 2, y, { align: 'center' });
  //   y += 10;
  
  //   addPageBorderAndNumber();
  
  //   const addSchoolEntry = (school, x, y, serialNumber) => {
  //     const startY = y;
      
  //     // Add black background for school name
  //     doc.setFillColor(0, 0, 0);
  //     doc.rect(x, y - 4, pageWidth - margins.left - margins.right, 6, 'F');
      
  //     doc.setFontSize(12);
  //     doc.setFont(undefined, 'bold');
  //     doc.setTextColor(255, 255, 255); // White color for school name
  //     y = addTextWithPageBreak(`${serialNumber}. ${school.name}`, x, y);
  //     y += 2; // Extra space after school name
  
  //     doc.setFontSize(10);
  //     doc.setFont(undefined, 'normal');
  //     doc.setTextColor(0); // Reset to black for other text
      
  //     y = addTextWithPageBreak(`${school.address_1}, ${school.address_2}`, x, y);
  //     y = addTextWithPageBreak(`${school.city}, ${school.state}, ${school.zip}`, x, y);
  //     y = addTextWithPageBreak(school.email, x, y);
  //     if (school.website) {
  //       y = addTextWithPageBreak(school.website, x, y);
  //     }
  
  //     y += 2;
  
  //     // Group faculty members
  //     const headOfSchool = [];
  //     const athleticManager = [];
  //     const otherFaculty = [];
  
  //     school.school_faculties?.forEach(faculty => {
  //       let isHeadOfSchool = false;
  //       let isAthleticManager = false;
  //       let isOthers = false;
        
  //       faculty.faculty_multiple_positions.forEach(position => {
  //         if (position.faculty_position.name === "Head of school") {
  //           isHeadOfSchool = true;
  //         } 
  //         if (position.faculty_position.name === "Athletic Director") {
  //           isAthleticManager = true;
  //         } 
  //         if (position.faculty_position.name !== "Athletic Director" && position.faculty_position.name !== "Head of school") {
  //           isOthers = true;
  //         }
  //       });
  
  //       if (isHeadOfSchool) {
  //         headOfSchool.push(faculty);
  //       }
  //       if (isAthleticManager) {
  //         athleticManager.push(faculty);
  //       } 
  //       if (isOthers) {
  //         otherFaculty.push(faculty);
  //       }
  //     });
  
  //     const addFacultySection = (title, facultyList) => {
  //       if (facultyList.length > 0) {
  //         doc.setFont(undefined, 'bold');
  //         y = addTextWithPageBreak(title, x, y);
  //         doc.setFont(undefined, 'normal');
  //         facultyList.forEach(faculty => {
  //           y = addFacultyMember(faculty, x, y);
  //           y += 2;
  //         });
  //       }
  //     };
  
  //     addFacultySection('Head of School', headOfSchool);
  //     addFacultySection('Athletic Manager', athleticManager);
  //     addFacultySection('Other Faculty', otherFaculty);
  
  //     return y - startY; // Return the height of the school entry
  //   };
  
  //   const addFacultyMember = (faculty, x, y) => {
  //     y = addTextWithPageBreak(`${faculty.title} ${faculty.first_name} ${faculty.middle_name} ${faculty.last_name}`, x, y);
  //     if (faculty.email) {
  //       y = addTextWithPageBreak(faculty.email, x, y);
  //     }
  //     if (!faculty.faculty_multiple_positions.some(pos => 
  //       pos.faculty_position.name === "Head of school" || 
  //       pos.faculty_position.name === "Athletic Director")) {
  //       faculty.faculty_multiple_positions.forEach(position => {
  //         y = addTextWithPageBreak(`  - ${position.faculty_position.name}`, x, y);
  //       });
  //     }
  //     return y;
  //   };
  
  //   // Add schools to the PDF
  //   for (let i = 0; i < resultall.length; i++) {
  //     const school = resultall[i];
      
  //     const height = addSchoolEntry(school, margins.left, y, i + 1);
  //     y += height + 10; // Move down for the next school
  
  //     if (y > pageHeight - margins.bottom - 40) {
  //       doc.addPage();
  //       y = margins.top;
  //       page++;
  //       addPageBorderAndNumber();
  //     }
  //   }
  
  //   doc.save('schools_directory.pdf');
  // };
  const generatePDFoneschool = (resultall) => {
    const doc = new jsPDF('p', 'mm', 'a4');
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
  
    // Set margins
    const margins = { top: 20, bottom: 20, left: 10, right: 10 };
    let y = margins.top;
    let page = 1;
  
    const addPageBorderAndNumber = () => {
      doc.setDrawColor(0);
      doc.setLineWidth(0.5);
      doc.rect(margins.left - 5, margins.top - 5, pageWidth - margins.left - margins.right + 10, pageHeight - margins.top - margins.bottom + 15);
      doc.setFontSize(10);
      const pageNumberYPosition = pageHeight - margins.bottom + 18;
      doc.text(`Page ${page}`, pageWidth / 2, pageNumberYPosition, { align: 'center' });
    };
  
    const addTextWithPageBreak = (text, x, y) => {
      const maxY = pageHeight - margins.bottom - 10;
      if (y > maxY) {
        doc.addPage();
        y = margins.top;
        page++;
        addPageBorderAndNumber();
      }
      doc.text(text, x, y);
      return y + 4;
    };
  
    // Add title
    doc.setFontSize(16);
    doc.setFont(undefined, 'bold');
    doc.setTextColor(255, 0, 0); // Red color
    doc.text('Schools Directory', pageWidth / 2, y, { align: 'center' });
    y += 10;
  
    addPageBorderAndNumber();
  
    const addSchoolEntry = (school, x, y, serialNumber) => {
      const startY = y;
      
      // Add black background for school name
      doc.setFillColor(0, 0, 0);
      doc.rect(x, y - 4, pageWidth - margins.left - margins.right, 6, 'F');
      
      doc.setFontSize(12);
      doc.setFont(undefined, 'bold');
      doc.setTextColor(255, 255, 255); // White color for school name
      y = addTextWithPageBreak(`${serialNumber}. ${school.name}`, x, y);
      y += 2; // Extra space after school name
  
      doc.setFontSize(10);
      doc.setFont(undefined, 'normal');
      doc.setTextColor(0); // Reset to black for other text
      
      y = addTextWithPageBreak(`${school.address_1}, ${school.address_2}`, x, y);
      y = addTextWithPageBreak(`${school.city}, ${school.state}, ${school.zip}`, x, y);
      y = addTextWithPageBreak(school.email, x, y);
      if (school.website) {
        y = addTextWithPageBreak(school.website, x, y);
      }
  
      y += 2;
  
      // Group faculty members
      const headOfSchool = [];
      const athleticManager = [];
      const otherFaculty = [];
  
      school.school_faculties?.forEach(faculty => {
        let isHeadOfSchool = false;
        let isAthleticManager = false;
        let isOthers = false;
        
        faculty.faculty_multiple_positions.forEach(position => {
          if (position.faculty_position.name === "Head of school") {
            isHeadOfSchool = true;
          } 
          if (position.faculty_position.name === "Athletic Director") {
            isAthleticManager = true;
          } 
          if (position.faculty_position.name !== "Athletic Director" && position.faculty_position.name !== "Head of school") {
            isOthers = true;
          }
        });
  
        if (isHeadOfSchool) {
          headOfSchool.push(faculty);
        }
        if (isAthleticManager) {
          athleticManager.push(faculty);
        } 
        if (isOthers) {
          otherFaculty.push(faculty);
        }
      });
  
      const addFacultySection = (title, facultyList) => {
        if (facultyList.length > 0) {
          doc.setFont(undefined, 'bold');
          y = addTextWithPageBreak(title, x, y);
          doc.setFont(undefined, 'normal');
          facultyList.forEach(faculty => {
            y = addFacultyMember(faculty, x, y, title);
            y += 2;
          });
        }
      };
  
      addFacultySection('Head of School', headOfSchool);
      addFacultySection('Athletic Manager', athleticManager);
      addFacultySection('Other Faculty', otherFaculty);
  
      return y - startY; // Return the height of the school entry
    };
  
    const addFacultyMember = (faculty, x, y, sectionTitle) => {
      // Add name
      y = addTextWithPageBreak(`${faculty.title} ${faculty.first_name} ${faculty.middle_name} ${faculty.last_name}`, x, y);
      
      // Add email if available
      if (faculty.email) {
        y = addTextWithPageBreak(faculty.email, x, y);
      }
      
      // Only show positions for 'Other Faculty'
      if (sectionTitle === 'Other Faculty') {
        faculty.faculty_multiple_positions.forEach(position => {
          if (position.faculty_position.name !== "Head of school" && 
              position.faculty_position.name !== "Athletic Director") {
            y = addTextWithPageBreak(`  - ${position.faculty_position.name}`, x, y);
          }
        });
      }
      
      return y;
    };
  
    // Add schools to the PDF
    for (let i = 0; i < resultall.length; i++) {
      const school = resultall[i];
      
      const height = addSchoolEntry(school, margins.left, y, i + 1);
      y += height + 10; // Move down for the next school
  
      if (y > pageHeight - margins.bottom - 40) {
        doc.addPage();
        y = margins.top;
        page++;
        addPageBorderAndNumber();
      }
    }
  
    doc.save('schools_directory.pdf');
};
const generatePDF2 = () => {
  const doc = new jsPDF('p', 'mm', 'a4');
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  // Set margins and column width
  const margins = { top: 20, bottom: 20, left: 10, right: 10 };
  const columnWidth = (pageWidth - margins.left - margins.right) / 2;
  let y = margins.top;
  let page = 1;

  const addPageBorderAndNumber = () => {
      doc.setDrawColor(0);
      doc.setLineWidth(0.5);
      doc.rect(margins.left - 5, margins.top - 5, pageWidth - margins.left - margins.right + 10, pageHeight - margins.top - margins.bottom + 15);
      doc.setFontSize(10);
      const pageNumberYPosition = pageHeight - margins.bottom + 18;
      doc.text(`Page ${page}`, pageWidth / 2, pageNumberYPosition, { align: 'center' });
  };

  const checkNewPage = (currentY, lineHeight = 4) => {
      if (currentY + lineHeight > pageHeight - margins.bottom - 10) {
          doc.addPage();
          page++;
          addPageBorderAndNumber();
          return margins.top;
      }
      return currentY;
  };

  // Add title
  doc.setFontSize(16);
  doc.setFont(undefined, 'bold');
  doc.setTextColor(255, 0, 0);
  doc.text('Schools Directory', pageWidth / 2, y, { align: 'center' });
  y += 7;

  addPageBorderAndNumber();

   const formatFacultyGroups = (faculty) => {
      const groups = {
          headOfSchool: [],
          athleticManager: [],
          otherFaculty: []
      };

      faculty?.forEach(member => {
          let isHeadOfSchool = false;
          let isAthleticManager = false;
          let hasOtherPositions = false;

          // Check all positions
          member.faculty_multiple_positions.forEach(position => {
              if (position.faculty_position.name === "Head of school") {
                  isHeadOfSchool = true;
              } else if (position.faculty_position.name === "Athletic Director") {
                  isAthleticManager = true;
              } else {
                  hasOtherPositions = true;
              }
          });

          // Add to respective groups
          if (isHeadOfSchool) {
              groups.headOfSchool.push(member);
          }
          if (isAthleticManager) {
              groups.athleticManager.push(member);
          }
          // Add to otherFaculty if they have any position other than Head/Athletic
          if (hasOtherPositions) {
              groups.otherFaculty.push(member);
          }
      });

      return groups;
  };

  // const formatFacultyGroups = (faculty) => {
  //     const groups = {
  //         headOfSchool: [],
  //         athleticManager: [],
  //         otherFaculty: []
  //     };

  //     faculty?.forEach(member => {
  //         let categorized = false;
  //         member.faculty_multiple_positions.forEach(position => {
  //             if (position.faculty_position.name === "Head of school") {
  //                 groups.headOfSchool.push(member);
  //                 categorized = true;
  //             } else if (position.faculty_position.name === "Athletic Director") {
  //                 groups.athleticManager.push(member);
  //                 categorized = true;
  //             }
  //         });
  //         if (!categorized) {
  //             groups.otherFaculty.push(member);
  //         }
  //     });

  //     return groups;
  // };

  const addAlignedLine = (text1, text2, currentY, isHeader = false) => {
      currentY = checkNewPage(currentY);
      
      const col1X = margins.left;
      const col2X = margins.left + columnWidth + 5;
      
      if (isHeader) {
          doc.setFillColor(0, 0, 0);
          doc.rect(col1X, currentY - 4, columnWidth - 3, 6, 'F');
          if (text2) {
              doc.rect(col2X, currentY - 4, columnWidth - 3, 6, 'F');
          }
          doc.setTextColor(255, 255, 255);
      } else {
          doc.setTextColor(0);
      }

      if (text1?.trim()) doc.text(text1, col1X, currentY);
      if (text2?.trim()) doc.text(text2, col2X, currentY);

      return currentY + 4;
  };

  // Process schools in pairs
  for (let i = 0; i < resultall.length; i += 2) {
      const school1 = resultall[i];
      const school2 = i + 1 < resultall.length ? resultall[i + 1] : null;

      y = checkNewPage(y);

      // Add school names (headers)
      doc.setFontSize(12);
      doc.setFont(undefined, 'bold');
      y = addAlignedLine(
          `${i + 1}. ${school1.name}`,
          school2 ? `${i + 2}. ${school2.name}` : '',
          y,
          true
      );
      y += 2;

      // Reset font settings for regular content
      doc.setFontSize(10);
      doc.setFont(undefined, 'normal');

      // Add address and contact information
      if (school1.address_1 || (school2 && school2.address_1)) {
          y = addAlignedLine(
              school1.address_1 ? `${school1.address_1}, ${school1.address_2}` : '',
              school2?.address_1 ? `${school2.address_1}, ${school2.address_2}` : '',
              y
          );
      }

      if (school1.city || (school2 && school2.city)) {
          y = addAlignedLine(
              school1.city ? `${school1.city}, ${school1.state}, ${school1.zip}` : '',
              school2?.city ? `${school2.city}, ${school2.state}, ${school2.zip}` : '',
              y
          );
      }

      if (school1.email || (school2 && school2.email)) {
          y = addAlignedLine(
              school1.email || '',
              school2?.email || '',
              y
          );
      }

      if (school1.website || (school2 && school2.website)) {
          y = addAlignedLine(
              school1.website || '',
              school2?.website || '',
              y
          );
      }

      y += 2;

      // Process faculty sections
      const faculty1 = formatFacultyGroups(school1.school_faculties);
      const faculty2 = school2 ? formatFacultyGroups(school2.school_faculties) : null;

      // Helper function to add faculty section only if there's data
      const addFacultySection = (title, list1, list2) => {
          if (!list1?.length && !list2?.length) return;

          // Add section header
          doc.setFont(undefined, 'bold');
          y = addAlignedLine(
              list1?.length ? title : '',
              list2?.length ? title : '',
              y
          );
          doc.setFont(undefined, 'normal');

          const maxLength = Math.max(list1?.length || 0, list2?.length || 0);

          for (let j = 0; j < maxLength; j++) {
              const member1 = list1?.[j];
              const member2 = list2?.[j];

              if (member1 || member2) {
                  y = addAlignedLine(
                      member1 ? `${member1.title} ${member1.first_name} ${member1.middle_name} ${member1.last_name}` : '',
                      member2 ? `${member2.title} ${member2.first_name} ${member2.middle_name} ${member2.last_name}` : '',
                      y
                  );

                  if (member1?.email || member2?.email) {
                      y = addAlignedLine(
                          member1?.email || '',
                          member2?.email || '',
                          y
                      );
                  }

                  // Add positions for other faculty
                  if (title === 'Other Faculty') {
                      const positions1 = member1?.faculty_multiple_positions || [];
                      const positions2 = member2?.faculty_multiple_positions || [];
                      const maxPositions = Math.max(positions1.length, positions2.length);

                      for (let k = 0; k < maxPositions; k++) {
                          y = addAlignedLine(
                              positions1[k] ? `  - ${positions1[k].faculty_position.name}` : '',
                              positions2[k] ? `  - ${positions2[k].faculty_position.name}` : '',
                              y
                          );
                      }
                  }
              }
          }
          y += 2;
      };

      // Only add sections that have data
      if (faculty1.headOfSchool.length || (faculty2 && faculty2.headOfSchool.length)) {
          addFacultySection('Head of School', faculty1.headOfSchool, faculty2?.headOfSchool);
      }

      if (faculty1.athleticManager.length || (faculty2 && faculty2.athleticManager.length)) {
          addFacultySection('Athletic Manager', faculty1.athleticManager, faculty2?.athleticManager);
      }

      if (faculty1.otherFaculty.length || (faculty2 && faculty2.otherFaculty.length)) {
          addFacultySection('Other Faculty', faculty1.otherFaculty, faculty2?.otherFaculty);
      }

      y += 8; // Space between school pairs
  }

  doc.save('schools_directory.pdf');
};


// const generatePDF2 = () => {
//     const doc = new jsPDF('p', 'mm', 'a4');
//     const pageWidth = doc.internal.pageSize.getWidth();
//     const pageHeight = doc.internal.pageSize.getHeight();

//     // Set margins and column width
//     const margins = { top: 20, bottom: 20, left: 10, right: 10 };
//     const columnWidth = (pageWidth - margins.left - margins.right) / 2;
//     let y = margins.top;
//     let page = 1;

//     const addPageBorderAndNumber = () => {
//         doc.setDrawColor(0);
//         doc.setLineWidth(0.5);
//         doc.rect(margins.left - 5, margins.top - 5, pageWidth - margins.left - margins.right + 10, pageHeight - margins.top - margins.bottom + 15);
//         doc.setFontSize(10);
//         const pageNumberYPosition = pageHeight - margins.bottom + 18;
//         doc.text(`Page ${page}`, pageWidth / 2, pageNumberYPosition, { align: 'center' });
//     };

//     const checkNewPage = (currentY, lineHeight = 4) => {
//         if (currentY + lineHeight > pageHeight - margins.bottom - 10) {
//             doc.addPage();
//             page++;
//             addPageBorderAndNumber();
//             return margins.top;
//         }
//         return currentY;
//     };

//     // Add title
//     doc.setFontSize(16);
//     doc.setFont(undefined, 'bold');
//     doc.setTextColor(255, 0, 0);
//     doc.text('Schools Directory', pageWidth / 2, y, { align: 'center' });
//     y += 7;

//     addPageBorderAndNumber();

//     const formatFacultyGroups = (faculty) => {
//         const groups = {
//             headOfSchool: [],
//             athleticManager: [],
//             otherFaculty: []
//         };

//         faculty?.forEach(member => {
//             let isHeadOfSchool = false;
//             let isAthleticManager = false;
//             let hasOtherPositions = false;

//             member.faculty_multiple_positions.forEach(position => {
//                 if (position.faculty_position.name === "Head of school") {
//                     isHeadOfSchool = true;
//                 } else if (position.faculty_position.name === "Athletic Director") {
//                     isAthleticManager = true;
//                 } else {
//                     hasOtherPositions = true;
//                 }
//             });

//             if (isHeadOfSchool) {
//                 groups.headOfSchool.push(member);
//             }
//             if (isAthleticManager) {
//                 groups.athleticManager.push(member);
//             }
//             if (hasOtherPositions) {
//                 groups.otherFaculty.push(member);
//             }
//         });

//         return groups;
//     };

//     const addSchoolContent = (school, x, index) => {
//         // School name header
//         doc.setFontSize(12);
//         doc.setFont(undefined, 'bold');
//         doc.setFillColor(0, 0, 0);
//         doc.rect(x, y - 4, columnWidth - 3, 6, 'F');
//         doc.setTextColor(255, 255, 255);
//         doc.text(`${index}. ${school.name}`, x, y);
        
//         // Reset font settings for regular content
//         doc.setFontSize(10);
//         doc.setFont(undefined, 'normal');
//         doc.setTextColor(0);
        
//         let localY = y + 6;

//         // Address and contact information
//         if (school.address_1) {
//             doc.text(`${school.address_1}, ${school.address_2}`, x, localY);
//             localY += 4;
//         }
//         if (school.city) {
//             doc.text(`${school.city}, ${school.state}, ${school.zip}`, x, localY);
//             localY += 4;
//         }
//         if (school.email) {
//             doc.text(school.email, x, localY);
//             localY += 4;
//         }
//         if (school.website) {
//             doc.text(school.website, x, localY);
//             localY += 4;
//         }

//         localY += 2;

//         // Process faculty sections
//         const faculty = formatFacultyGroups(school.school_faculties);

//         // Helper function to add faculty section
//         const addFacultySection = (title, list) => {
//             if (!list?.length) return localY;

//             doc.setFont(undefined, 'bold');
//             doc.text(title, x, localY);
//             doc.setFont(undefined, 'normal');
//             localY += 4;

//             list.forEach(member => {
//                 localY = checkNewPage(localY);
//                 doc.text(`${member.title} ${member.first_name} ${member.middle_name} ${member.last_name}`, x, localY);
//                 localY += 4;

//                 if (member.email) {
//                     doc.text(member.email, x, localY);
//                     localY += 4;
//                 }

//                 if (title === 'Other Faculty') {
//                     member.faculty_multiple_positions.forEach(position => {
//                         doc.text(`  - ${position.faculty_position.name}`, x, localY);
//                         localY += 4;
//                     });
//                 }
//             });

//             return localY + 2;
//         };

//         // Add faculty sections independently
//         if (faculty.headOfSchool.length) {
//             localY = addFacultySection('Head of School', faculty.headOfSchool);
//         }
//         if (faculty.athleticManager.length) {
//             localY = addFacultySection('Athletic Manager', faculty.athleticManager);
//         }
//         if (faculty.otherFaculty.length) {
//             localY = addFacultySection('Other Faculty', faculty.otherFaculty);
//         }

//         return localY;
//     };

//     // Process schools in pairs
//     for (let i = 0; i < resultall.length; i += 2) {
//         const school1 = resultall[i];
//         const school2 = i + 1 < resultall.length ? resultall[i + 1] : null;

//         y = checkNewPage(y);
        
//         // Calculate heights for both schools
//         const school1Height = addSchoolContent(school1, margins.left, i + 1);
//         let school2Height = y;
//         if (school2) {
//             school2Height = addSchoolContent(school2, margins.left + columnWidth + 5, i + 2);
//         }

//         // Set y to the maximum height for next pair
//         y = Math.max(school1Height, school2Height) + 8;
//     }

//     doc.save('schools_directory.pdf');
// };
   
//   const generatePDF2 = () => {
//     const doc = new jsPDF('p', 'mm', 'a4');
//     const pageWidth = doc.internal.pageSize.getWidth();
//     const pageHeight = doc.internal.pageSize.getHeight();

//     // Set margins and column width
//     const margins = { top: 20, bottom: 20, left: 10, right: 10 };
//     const columnWidth = (pageWidth - margins.left - margins.right) / 2;
//     let y = margins.top;
//     let page = 1;

//     const addPageBorderAndNumber = () => {
//         doc.setDrawColor(0);
//         doc.setLineWidth(0.5);
//         doc.rect(margins.left - 5, margins.top - 5, pageWidth - margins.left - margins.right + 10, pageHeight - margins.top - margins.bottom + 15);
//         doc.setFontSize(10);
//         const pageNumberYPosition = pageHeight - margins.bottom + 18;
//         doc.text(`Page ${page}`, pageWidth / 2, pageNumberYPosition, { align: 'center' });
//     };

//     // Helper function to check if new page is needed and add it
//     const checkNewPage = (currentY, lineHeight = 4) => {
//         if (currentY + lineHeight > pageHeight - margins.bottom - 10) {
//             doc.addPage();
//             page++;
//             addPageBorderAndNumber();
//             return margins.top;
//         }
//         return currentY;
//     };

//     // Add title
//     doc.setFontSize(16);
//     doc.setFont(undefined, 'bold');
//     doc.setTextColor(255, 0, 0);
//     doc.text('Schools Directory', pageWidth / 2, y, { align: 'center' });
//     y += 7;

//     addPageBorderAndNumber();

//     const formatFacultyGroups = (faculty) => {
//         const groups = {
//             headOfSchool: [],
//             athleticManager: [],
//             otherFaculty: []
//         };

//         faculty?.forEach(member => {
//             let categorized = false;
//             member.faculty_multiple_positions.forEach(position => {
//                 if (position.faculty_position.name === "Head of school") {
//                     groups.headOfSchool.push(member);
//                     categorized = true;
//                 } else if (position.faculty_position.name === "Athletic Director") {
//                     groups.athleticManager.push(member);
//                     categorized = true;
//                 }
//             });
//             if (!categorized) {
//                 groups.otherFaculty.push(member);
//             }
//         });

//         return groups;
//     };

//     // Function to add a line of text with strict alignment
//     const addAlignedLine = (text1, text2, currentY, isHeader = false) => {
//         currentY = checkNewPage(currentY);
        
//         const col1X = margins.left;
//         const col2X = margins.left + columnWidth + 5;
        
//         if (isHeader) {
//             doc.setFillColor(0, 0, 0);
//             doc.rect(col1X, currentY - 4, columnWidth - 3, 6, 'F');
//             if (text2) {
//                 doc.rect(col2X, currentY - 4, columnWidth - 3, 6, 'F');
//             }
//             doc.setTextColor(255, 255, 255);
//         } else {
//             doc.setTextColor(0);
//         }

//         doc.text(text1 || '', col1X, currentY);
//         if (text2) {
//             doc.text(text2, col2X, currentY);
//         }

//         return currentY + 4; // Standard line height
//     };

//     // Process schools in pairs
//     for (let i = 0; i < resultall.length; i += 2) {
//         const school1 = resultall[i];
//         const school2 = i + 1 < resultall.length ? resultall[i + 1] : null;

//         // Check for new page before starting new school pair
//         y = checkNewPage(y);

//         // Add school names (headers)
//         doc.setFontSize(12);
//         doc.setFont(undefined, 'bold');
//         y = addAlignedLine(
//             `${i + 1}. ${school1.name}`,
//             school2 ? `${i + 2}. ${school2.name}` : '',
//             y,
//             true
//         );
//         y += 2; // Extra space after headers

//         // Reset font settings for regular content
//         doc.setFontSize(10);
//         doc.setFont(undefined, 'normal');

//         // Add address lines with strict alignment
//         y = addAlignedLine(
//             `${school1.address_1}, ${school1.address_2}`,
//             school2 ? `${school2.address_1}, ${school2.address_2}` : '',
//             y
//         );

//         y = addAlignedLine(
//             `${school1.city}, ${school1.state}, ${school1.zip}`,
//             school2 ? `${school2.city}, ${school2.state}, ${school2.zip}` : '',
//             y
//         );

//         // Add contact information with strict alignment
//         y = addAlignedLine(
//             school1.email,
//             school2 ? school2.email : '',
//             y
//         );

//         if (school1.website || (school2 && school2.website)) {
//             y = addAlignedLine(
//                 school1.website || '',
//                 school2 ? school2.website : '',
//                 y
//             );
//         }

//         y += 2; // Space before faculty sections

//         // Process faculty sections
//         const faculty1 = formatFacultyGroups(school1.school_faculties);
//         const faculty2 = school2 ? formatFacultyGroups(school2.school_faculties) : null;

//         // Helper function to add faculty section with strict alignment
//         const addFacultySection = (title, list1, list2) => {
//             if (list1.length === 0 && (!list2 || list2.length === 0)) return;

//             // Add section header
//             doc.setFont(undefined, 'bold');
//             y = addAlignedLine(title, school2 ? title : '', y);
//             doc.setFont(undefined, 'normal');

//             // Calculate max length for alignment
//             const maxLength = Math.max(list1.length, list2 ? list2.length : 0);

//             // Add faculty members with strict alignment
//             for (let j = 0; j < maxLength; j++) {
//                 const member1 = list1[j];
//                 const member2 = list2 ? list2[j] : null;

//                 if (member1 || member2) {
//                     y = addAlignedLine(
//                         member1 ? `${member1.title} ${member1.first_name} ${member1.middle_name} ${member1.last_name}` : '',
//                         member2 ? `${member2.title} ${member2.first_name} ${member2.middle_name} ${member2.last_name}` : '',
//                         y
//                     );

//                     // Add email addresses if they exist
//                     if (member1?.email || (member2?.email)) {
//                         y = addAlignedLine(
//                             member1?.email || '',
//                             member2?.email || '',
//                             y
//                         );
//                     }

//                     // Add positions for other faculty
//                     if (title === 'Other Faculty') {
//                         if (member1) {
//                             member1.faculty_multiple_positions.forEach(position => {
//                                 y = addAlignedLine(
//                                     `  - ${position.faculty_position.name}`,
//                                     '',
//                                     y
//                                 );
//                             });
//                         }
//                         if (member2) {
//                             member2.faculty_multiple_positions.forEach(position => {
//                                 y = addAlignedLine(
//                                     '',
//                                     `  - ${position.faculty_position.name}`,
//                                     y
//                                 );
//                             });
//                         }
//                     }
//                 }
//             }
//             y += 2; // Space after section
//         };

//         // Add faculty sections with strict alignment
//         addFacultySection('Head of School', faculty1.headOfSchool, faculty2?.headOfSchool);
//         addFacultySection('Athletic Manager', faculty1.athleticManager, faculty2?.athleticManager);
//         addFacultySection('Other Faculty', faculty1.otherFaculty, faculty2?.otherFaculty);

//         y += 8; // Space between school pairs
//     }

//     doc.save('schools_directory.pdf');
// };
  const generatePDF = () => {
    const doc = new jsPDF('p', 'pt', 'a4'); // A4 size in portrait
    const content = pdfRef.current;
    
    // Set top and bottom margins
    const topMargin = 40; // Adjust this value for top margin
    const bottomMargin = 40; // Adjust this value for bottom margin
    
    // Render the HTML into the PDF with page breaks
    doc.html(content, {
      callback: (doc) => {
        doc.save('school-directory.pdf');
      },
      x: 10,           // Left margin
      y: topMargin,    // Top margin
      width: 580,      // Content width, ensuring minimal side margins
      windowWidth: 800, // For accurate scaling
      margin: [topMargin, 10, bottomMargin, 10], // [top, left, bottom, right] margins
     
      html2canvas: {
        scale: 0.6,     // Scale down to fit content (adjust as necessary)
        useCORS: true,  // Enable cross-origin for any images or content
      },
      // Page splitting is handled by jsPDF automatically based on content height
    });
  };
  
  return (
    <div>
      <div id="school-directory-content" ref={pdfRef} className="p-4" style={{ fontSize: '12px' ,dispaly:'none'}}>
        <h1 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '20px', color: 'red' }}>School Directory</h1>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
          {resultall.map((school, index) => (
            <div key={school.id} style={{ padding: '20px', borderRadius: '4px', fontSize: '14px' }}>
              <h2 style={{
                  fontSize: '18px', 
                  fontWeight: 'bold', 
                  marginBottom: '10px', 
                  backgroundColor: 'black', 
                  color: 'white', 
                  padding: '10px' 
                }}>
                {index + 1}. {school.name}
              </h2>
              <div className="school-entry" style={{ marginBottom: '15px', fontSize: '14px' }}>
                <p>{school.address_1}, {school.address_2}</p>
                <p>{school.city}, {school.state}, {school.zip}</p>
                <p>{school.email}</p>
                {school.website && <p>{school.website}</p>}
              </div>
      
              {/* Head of School Section */}
              {school.school_faculties && school.school_faculties.filter(faculty => faculty.faculty_multiple_positions.some(position => position.faculty_position.name === "Head of school")).length > 0 && (
                <div style={{ marginTop: '16px', fontSize: '14px' }}>
                  <h6 style={{ fontWeight: 'bold', marginBottom: '8px' }}>Head of School</h6>
                  {school.school_faculties.filter(faculty => faculty.faculty_multiple_positions.some(position => position.faculty_position.name === "Head of school")).map((faculty, fIndex) => (
                    <p key={faculty.id}>
                      {faculty.title} {faculty.first_name} {faculty.middle_name} {faculty.last_name}
                      {faculty.email && <span> - {faculty.email}</span>}
                    </p>
                  ))}
                </div>
              )}
      
              {/* Athletic Manager Section */}
              {school.school_faculties && school.school_faculties.filter(faculty => faculty.faculty_multiple_positions.some(position => position.faculty_position.name === "Athletic manager")).length > 0 && (
                <div style={{ marginTop: '16px', fontSize: '14px' }}>
                  <h6 style={{ fontWeight: 'bold', marginBottom: '8px' }}>Athletic Manager</h6>
                  {school.school_faculties.filter(faculty => faculty.faculty_multiple_positions.some(position => position.faculty_position.name === "Athletic manager")).map((faculty, fIndex) => (
                    <p key={faculty.id}>
                      {faculty.title} {faculty.first_name} {faculty.middle_name} {faculty.last_name}
                      {faculty.email && <span> - {faculty.email}</span>}
                    </p>
                  ))}
                </div>
              )}
      
              {/* Additional Faculties Section */}
              {school.school_faculties.length > 0 && (
                <div style={{ marginTop: '16px', fontSize: '14px' }}>
                  <ul style={{ paddingLeft: '20px' }}>
                    {school.school_faculties.filter(faculty => faculty.faculty_multiple_positions.some(position => position.faculty_position.name !== "Head of school" && position.faculty_position.name !== "Athletic manager")).map((faculty, fIndex) => (
                      <li key={faculty.id}>
                        {fIndex + 1}. {faculty.title} {faculty.first_name} {faculty.middle_name} {faculty.last_name}
                        {/* Display email and positions without bullets */}
                        <div>{faculty.email}</div>
                        <div>
                          {faculty.faculty_multiple_positions.filter(position => position.faculty_position.name !== "Head of school" && position.faculty_position.name !== "Athletic manager").map((position, pIndex) => (
                            <span key={pIndex}> {position.faculty_position.name}{pIndex < faculty.faculty_multiple_positions.length - 1 ? ', ' : ''}</span> // comma separated positions
                          ))}
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              
            </div>
          ))}
        </div>
      </div>
  
      <button onClick={generatePDF} style={{ margin: '20px' }}>Download PDF</button>
      <button onClick={() => generatePDF2(resultall)} style={{ margin: '20px' }}>Generate PDF two school</button>
      <button onClick={() => generatePDFoneschool(resultall)} style={{ margin: '20px' }}>Generate PDF one school</button>
    </div>
  );
};

export default SchooldirectoryPdf;
